import React from 'react';

import * as Colors from 'src/theme/colors';

type IconTileProps = {
  icon?: React.ReactNode;
  width?: number;
  height?: number;
  mb?: number;
  className?: string;
};

const IconTile = (props: IconTileProps) => {
  const {
    icon,
    width = 40,
    height = 40,
    mb = 1.5,
    className,
    ...others
  } = props;
  const marginBottom = mb * 8; // Convert MUI spacing to px
  const fontSize = Math.min(width, height);
  return (
    <div
      className={`flex items-center justify-center rounded text-[#6B6F76] ${className || ''}`}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        marginBottom: `${marginBottom}px`,
        backgroundColor: Colors.HoverNonBorderBackground,
        fontSize: `${fontSize}px`,
      }}
      {...others}
    >
      {icon}
    </div>
  );
};

export default IconTile;
